export default __webpack_public_path__ + "static/gcn-responsive-animation.webmsd-bcb012d210f246aa7302246d206ea892.webm";